import React from 'react';
import { connect } from 'react-redux';
import { useEffect} from 'react';
import { readTracking} from '../../redux/actions/Tracking/TrackingAction';
import TrackingTable from './TrackingTable';
function Tracking({trackings,readTracking}) {
    useEffect(() => {
        console.log('trackings',trackings);
        if (trackings && trackings.length==0)
            readTracking().catch((error) => {
                alert('Loading failed ' + error);
            });
    }, [trackings]);

    return (
        <>
            <TrackingTable trackings={trackings} />
        </>
    );
}
const mapStateToProps = (state) => {
    return {
        trackings: state.trackings,
    };
};
const mapDispatchToProps={
    readTracking,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tracking);
